import { baseState, baseMutations } from '@/store/mixins'
import productPriceSchema from '@/api/restaurant-sale/product-price-schema'
import { split } from 'lodash'

export const state = {
  ...baseState,
  product: [],
  category_id: [],
  pro_group_id: [],
  formViewDatas: []
}
export const getters = {
}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
  SET_CATEGORY_ID(state, value) {
    state.category_id = value
  },
  SET_GROUP_ID(state, value) {
    state.pro_group_id = value
  }
}
export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          category_id: context.state.category_id,
          pro_group_id: context.state.pro_group_id
        }
      },
      attrubutes
    )
    return productPriceSchema.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return productPriceSchema.store(data)
  },
  destroy(context, id) {
    return productPriceSchema.destroy(id)
  },
  update(context, { id, data }) {
    return productPriceSchema.update(id, data)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await productPriceSchema.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}
